import * as Types from "@zapier/reporting/src/graphql-types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CheckForceRefreshQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type CheckForceRefreshQuery = {
  __typename?: "Query";
  buildId: string;
  forceRefresh: boolean;
};

export const CheckForceRefreshDocument = gql`
  query CheckForceRefresh {
    buildId
    forceRefresh
  }
`;

/**
 * __useCheckForceRefreshQuery__
 *
 * To run a query within a React component, call `useCheckForceRefreshQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckForceRefreshQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckForceRefreshQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckForceRefreshQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CheckForceRefreshQuery,
    CheckForceRefreshQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CheckForceRefreshQuery,
    CheckForceRefreshQueryVariables
  >(CheckForceRefreshDocument, options);
}
export function useCheckForceRefreshLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckForceRefreshQuery,
    CheckForceRefreshQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckForceRefreshQuery,
    CheckForceRefreshQueryVariables
  >(CheckForceRefreshDocument, options);
}
export type CheckForceRefreshQueryHookResult = ReturnType<
  typeof useCheckForceRefreshQuery
>;
export type CheckForceRefreshLazyQueryHookResult = ReturnType<
  typeof useCheckForceRefreshLazyQuery
>;
export type CheckForceRefreshQueryResult = Apollo.QueryResult<
  CheckForceRefreshQuery,
  CheckForceRefreshQueryVariables
>;
